
export default {
    name: 'SvgOtherTrailer',
    props: {
        color: {
            type: String,
            default: '#615F5A',
        },
    },
};
